// extracted by mini-css-extract-plugin
export default {"root":"StatsGrid_root__0pH2E","label":"StatsGrid_label__CZemY","icon":"StatsGrid_icon__WLrja"};